import type {Provider} from '@angular/core';
import {ContactsFacade} from './facade/contacts.facade';
import {EventsFacade} from './facade/events.facade';
import {CONTACTS_API} from './services/contacts-api.port';
import {ContactsApiHttpAdapter} from './services/contacts-api.http.adapter';
import {CONTACTS_GROUPS_API} from './services/contacts-groups-api.port';
import {ContactsGroupsApiHttpAdapter} from './services/contacts-groups-api.http.adapter';
import {EVENT_MEMBERS_API} from './services/event-members-api.port';
import {EventMembersApiMockAdapter} from './services/event-members-api.mock.adapter';
import {EventMetadataMockStore} from './services/event-metadata.mock.store';
import {USER_EVENTS_API} from './services/user-events-api.port';
import {UserEventsApiMockAdapter} from './services/user-events-api.mock.adapter';

/** Root-level API bindings (drawer/modal use root injector). */
export const contactsApiProviders: Provider[] = [
  ContactsApiHttpAdapter,
  ContactsGroupsApiHttpAdapter,
  UserEventsApiMockAdapter,
  EventMembersApiMockAdapter,
  EventMetadataMockStore,
  {provide: CONTACTS_API, useExisting: ContactsApiHttpAdapter},
  {provide: CONTACTS_GROUPS_API, useExisting: ContactsGroupsApiHttpAdapter},
  {provide: USER_EVENTS_API, useExisting: UserEventsApiMockAdapter},
  {provide: EVENT_MEMBERS_API, useExisting: EventMembersApiMockAdapter},
];

/** Page-level providers (facade is scoped to contacts page). */
export const contactsProviders: Provider[] = [ContactsFacade, EventsFacade];

